import React, { useState, useEffect, useRef, useMemo } from 'react';
import Sidebar from './Sidebar';
import Canvas from './Canvas';
import PropertiesPanel from './PropertiesPanel';
import PreviewDialog from './PreviewDialog';
import {nonmemdefaultValues} from '../helpers/nonmemdefaultValues'

import { DndContext, closestCenter } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { getRowsFromFields } from '../helpers/getRowsFromFields';
import { generateSlug } from '../helpers/generateSlug';
import {useForm, FormProvider} from 'react-hook-form';
//import './components/search-bar.js';
import NewFormPopup from './NewFormPopup';

import { useSelector } from 'react-redux';
import { getAllForms, getFormById, saveForm as saveFormAPI } from '../APIS/formsAPI';
import { showSuccess, showError, showWarning, showInfo } from '../helpers/notifications';
import './FormDesigner.css';

const FormDesigner = () => {
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setPages] = useState([1]);
  const [pageDescriptions, setPageDescriptions] = useState({1: ''});
  const [forms,setForms] = useState([]);
  const [formTitle, setFormTitle] = useState()
  const [formDescription, setFormDescription] = useState()
  const [formSlug,setFormSlug] = useState('')
  const [id,setId] = useState(null) // Id of the saved / loaded Form Design
  const [showNewForm, setShowNewForm] = useState(false);

  // Loading states
  const [isLoadingForms, setIsLoadingForms] = useState(false);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const defaultValues = useMemo(() => ({nonmemdefaultValues}), []);
  const methods = useForm({ defaultValues });


  const prevId = useRef()

  const handleAddField = (fieldType) => {

    let name = `${fieldType.type}_${fields.length + 1}`
    let label = `${fieldType.label} Label` // always a string
    let colSpan = 1
    let companyNameField
    if(fieldType.type==='company') {
      const count = fields.filter(f => f.type === "company").length;
      const index = count + 1;
      companyNameField = `company_name_${index}`
      label = `Find Company ${index===1?'':`( ${index} )`}`
      name = `company_number_${index}`
      colSpan = 4
    }
    if(fieldType.type==='address') {
      colSpan=4
      name = fieldType.name
    }
    if(fieldType.type==='companydirectors') {
      colSpan=4
      name='companydirectors'
    }
    if(fieldType.type==='bankaccounts') {
      colSpan=4
      name='bankaccounts'
      label='Bank Account Details'
    }
    if(fieldType.type==='officers_and_pscs') {
      colSpan=4
      name='officers_and_pscs'
      label='Engagement Resolution List'
    }
    if(fieldType.type==='htmltemplateeditor') {
      colSpan=4
      name=`html_template_${fields.length + 1}`
      label='HTML Template'
    }

    const newField = {
      id: Date.now().toString(),
      type: fieldType.type,
      label,
      name,
      page: currentPage,
      colSpan,
      required: false,
      showRequiredIndicator: false,
      companyNameField
    };
    setFields([...fields, newField]);

  };

  const handleSelectField = (fieldId) => {
    const field = fields.find((f) => f.id === fieldId);
    setSelectedField(JSON.parse(JSON.stringify(field)));
  };

  const handleUpdateField = (updatedField) => {
    const updatedFields = fields.map((field) =>
      field.id === updatedField.id ? updatedField : field
    );
    setFields(updatedFields);
    setSelectedField(updatedField);
  };

  const handleRemoveField = (fieldId) => {
    setFields(fields.filter((field) => field.id !== fieldId));
    if (selectedField?.id === fieldId) {
      setSelectedField(null);
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = fields.findIndex((f) => f.id === active.id);
      const newIndex = fields.findIndex((f) => f.id === over.id);
      setFields((fields) => arrayMove(fields, oldIndex, newIndex));
    }
  };

  const addPage = () => {
    const newPage = Math.max(...pages) + 1;
    setPages([...pages, newPage]);
    setPageDescriptions({...pageDescriptions, [newPage]: ''});
    setCurrentPage(newPage);
  };

  const deletePage = (pageToDelete) => {
    if (fields.some(f => f.page === pageToDelete)) {
      showWarning("You must remove all fields from the page before deleting it.");
      return;
    }
    const newPages = pages.filter(p => p !== pageToDelete);
    const newDescriptions = {...pageDescriptions};
    delete newDescriptions[pageToDelete];
    setPages(newPages);
    setPageDescriptions(newDescriptions);
    setCurrentPage(newPages[0]);
  };
  const selPage = (e) => {
    setCurrentPage(parseInt(e.target.value))
  }
  const handlePageDescriptionChange = (e) => {
    setPageDescriptions({
      ...pageDescriptions,
      [currentPage]: e.target.value
    });
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      const currentIndex = pages.indexOf(currentPage);
      setCurrentPage(pages[currentIndex - 1]);
    }
  };

  const goToNextPage = () => {
    const currentIndex = pages.indexOf(currentPage);
    if (currentIndex < pages.length - 1) {
      setCurrentPage(pages[currentIndex + 1]);
    }
  };

  const renderPageTabs = () => (
    <div className="page-tabs">
      <div style={{marginBottom: '10px', textAlign: 'left'}}>
        <label style={{display: 'block', marginBottom: '5px', fontSize: '0.9rem'}}>
          Page {currentPage} Description:
        </label>
        <input
          type="text"
          value={pageDescriptions[currentPage] || ''}
          onChange={handlePageDescriptionChange}
          placeholder="Enter page description..."
          style={{width: '80%', padding: '5px', fontSize: '0.9rem'}}
        />
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <button
          className="page-nav-button"
          onClick={goToPreviousPage}
          disabled={pages.indexOf(currentPage) === 0}
          style={{padding: '5px 10px'}}
        >
          &lt; Prev
        </button>
        <select onChange={selPage} value={currentPage} style={{display: 'inline', width: '20%', margin: '0px 10px'}}>
        {pages.map((page) => (
          <option
            key={page}
            value={page}
          >
            Page {page}{pageDescriptions[page] ? ` - ${pageDescriptions[page]}` : ''}
          </option>
        ))}
        </select>
        <button
          className="page-nav-button"
          onClick={goToNextPage}
          disabled={pages.indexOf(currentPage) === pages.length - 1}
          style={{padding: '5px 10px'}}
        >
          Next &gt;
        </button>
        <button className="add-page-button" onClick={addPage}>+ Add Page</button>
        {pages.length > 1 && (
          <button className="delete-page-button" onClick={() => deletePage(currentPage)}>
            🗑 Delete Page
          </button>
        )}
      </div>
    </div>
  );

  const currentPageFields = fields.filter(f => f.page === currentPage);
  const rows = getRowsFromFields(currentPageFields);

    // Get all Forms for Choose from
    useEffect(() => {
      async function loadForms() {
        setIsLoadingForms(true);
        try {
          const result = await getAllForms(token);
          if (result.status) {
            setForms(result.data);
          } else {
            showError(`Error: ${result.error}`);
          }
        } catch(err) {
          showError(`There was an Error Loading forms: ${err.message}`)
        } finally {
          setIsLoadingForms(false);
        }
      }
      if (token) {
        loadForms();
      }
    },[token]);

  // Load our data
  useEffect(() => {
    async function loadForm(id) {
      prevId.current = id
      setIsLoadingForm(true);
      try {
        const result = await getFormById(id, token);
        if (result.status) {
          setFormTitle(result.data.title)
          setFormDescription(result.data.description)
          setFormSlug(result.data.slug)
          try {
            setFields(result.data.json_definition)
            // add all the pages
            let pgs = [];
            for(const field of result.data.json_definition){
              if(typeof field.page !== 'undefined') {
                if(!pgs.includes(parseInt(field.page)))
                  pgs.push(parseInt(field.page))
              }
            }
            setPages(pgs)

            // Load page descriptions
            if (result.data.pageDescriptions) {
              setPageDescriptions(result.data.pageDescriptions);
            } else {
              // Initialize empty descriptions for legacy forms
              const defaultDescriptions = {};
              pgs.forEach(page => defaultDescriptions[page] = '');
              setPageDescriptions(defaultDescriptions);
            }
          } catch(err) {
            showError(`There was an error retrieving the form data: ${err.message}`)
            return;
          }
          showSuccess("The form was successfully loaded.")
        } else {
          showError(`Error: ${result.error}`)
        }
      } catch(err) {
        showError(`There was an Error Loading the Form: ${err.message}`)
      } finally {
        setIsLoadingForm(false);
      }


    }
    if(id == null )
      return;
    if(id !== prevId.current)
      loadForm(id);

  },[id, token])


  const saveForm = async () => {
    let slug = formSlug
    if((formSlug??'') === '') {
      slug = generateSlug(formTitle)
      setFormSlug(slug)
    }

    setIsSaving(true);
    try {
      const formData = {
        title: formTitle,
        description: formDescription,
        slug,
        json_definition: fields,
        pageDescriptions: pageDescriptions,
        id
      };

      const result = await saveFormAPI(formData, token);

      if (result.status) {
        if (!(id??false) && result.id) {
          setId(result.id)
        }
        showSuccess("The form was successfully saved.")
      } else {
        showError(`Error: ${result.error}`)
      }
    } catch(err) {
      showError(`There was an Error Saving the Form: ${err.message}`)
    } finally {
      setIsSaving(false);
    }
  };

  const selForm = (e) => {
    setId(e.target.value)
  }

  const onNewFormCreated  = (id) => {
    setShowNewForm(false)
    showSuccess("New Form Has Been Created with ID: " + id)
    setId(id);
  }

  const onNewFormClose = () => {
    setShowNewForm(false);
  }

  return (



    <div>
      {showNewForm &&
        <NewFormPopup
          onSave={onNewFormCreated}
          onClose={onNewFormClose}
        />
      }
    <div style={{display: 'inline-block', width: '100%', padding: '10px', textAlign: 'left', fontSize: '0.8rem'}} >

        Select From<select id='selform' onChange={selForm} className='selform' disabled={isLoadingForms || isLoadingForm} >
          {isLoadingForms ? (
            <option>Loading forms...</option>
          ) : (
            forms.map(item => (
              <option key={item.id} value={item.id} >{item.title}</option>
            ))
          )}
        </select>
        {isLoadingForm && <span style={{marginLeft: '10px', color: '#0066cc'}}>Loading form...</span>}
        {id !== null && !isLoadingForm &&
        <div style={{display: 'inline', textAlign: 'left' }}>
          Form Name: <input className="formtitle" type='text'  id='formname' name='formname' value={formTitle} onChange={(e) => setFormTitle(e.target.value)} disabled={isSaving} />&nbsp;
          Description: <input className="formslug" type='text' id='formdesc' name='formdesc' value={formDescription} onChange={(e) => setFormDescription(e.target.value)} disabled={isSaving} />
          &nbsp;<button className="smltopbtns" type='button'  style={{display: 'inline'}}  onClick={()=> saveForm()} disabled={isSaving} >{isSaving ? 'Saving...' : 'Save Form'}</button>&nbsp;
        </div>
        }
        <input type='button' value='New Form'  style={{display: 'inline'}} className="smltopbtns" onClick={()=>setShowNewForm(true)} disabled={isLoadingForm || isSaving} />&nbsp;
        <button className="smltopbtns" onClick={() => setShowPreview(true)} disabled={isLoadingForm || isSaving}>Preview Form</button>
        </div>
      {id === null &&
        <div style={{textAlign:'center', marginTop: '20px'}}><h2>Please Select A Form To Edit or Add A New Form.</h2></div>
      }
      {id !== null &&
      <div style={{height: '90vh', overflow: 'hidden'}} >
        <div className="form-designer">
          <Sidebar onAddField={handleAddField} fields={fields} />
          <div className="main-panel">
            {renderPageTabs()}
            <div className='form-scroller'>
            <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
              <SortableContext items={currentPageFields.map((f) => f.id)} strategy={verticalListSortingStrategy}>
                <Canvas rows={rows} onSelectField={handleSelectField} onRemoveField={handleRemoveField} selectedField={selectedField} />
              </SortableContext>
            </DndContext>
            </div>

          </div>
          <PropertiesPanel component={selectedField} onUpdate={handleUpdateField} pages={pages} fields={fields} />
          <FormProvider {...methods} >
            <PreviewDialog open={showPreview} onClose={() => setShowPreview(false)} schema={fields} />
          </FormProvider>
        </div>
      </div>
    }
    </div>
  );
};

export default FormDesigner;
